import { useEffect, useState } from "react";

const ACTION_KEY_DEFAULT = ["Ctrl ", "Control"] as [string, string];
const ACTION_KEY_APPLE = ["⌘", "Command"] as [string, string];

export function useActionKey(): [string, string] {
  const [actionKey, setActionKey] = useState<[string, string] | undefined>(undefined);

  useEffect(() => {
    if (typeof navigator !== "undefined") {
      if (/(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)) {
        setActionKey(ACTION_KEY_APPLE);
      } else {
        setActionKey(ACTION_KEY_DEFAULT);
      }
    }
  }, []);

  return actionKey ?? ACTION_KEY_DEFAULT;
}
